import React from 'react';
import './loader.css';

const Loader = ({ size = '60px', message = 'Loading...' }) => {
    return (
        <div className="loader-wrapper">
            <div
                className="circle-loader"
                style={{ width: size, height: size }}
            ></div>
            {message && <p className="loader-text">{message}</p>}
        </div>
    );
};

export default Loader;
